import { render, staticRenderFns } from "./ReportStudentLoan.vue?vue&type=template&id=6abeddcc&scoped=true&"
import script from "./ReportStudentLoan.vue?vue&type=script&lang=js&"
export * from "./ReportStudentLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abeddcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
